<section class="custom-route__edit-route">
  @if (showEditInfo) {
    <app-edit-info 
      (gotItEditInfo)="gotItEditInfo()"
      (closeEditInfo)="closeEditInfo()" 
    />
  }
  
  @if (showBanner) {
    <app-banner-info 
      (closeBanner)="closeBanner()" 
      (showEditInfo)="openEditInfo()"
    />
  }
  
  <app-points />
  
  <app-action-buttons />
</section>
